import {
  AppBar,
  Box,
  Dialog,
  IconButton,
  Toolbar,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { tokens } from "../context/ThemeProvider";

export default function DetailDialog({ open, onClose, selectedData }) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const handleClose = () => {
    onClose();
  };

  const kuponList = selectedData?.daftarKupon
    ? selectedData.daftarKupon.split(",")
    : [];

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth={"md"}>
      <AppBar
        sx={{ position: "relative", backgroundColor: colors.primary[700] }}
      >
        <Toolbar>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h5" component="div">
            Detail Kupon - {selectedData?.name || "User"}
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box p={3}>
        <Typography variant="h6" gutterBottom>
          Total Kupon: {kuponList.length}
        </Typography>

        <Grid container spacing={2}>
          {kuponList.map((kupon, index) => (
            <Grid item xs={4} sm={3} md={2} key={index}>
              <Box
                sx={{
                  backgroundColor: colors.primary[600],
                  color: "#fff",
                  borderRadius: 2,
                  p: 2,
                  textAlign: "center",
                  fontWeight: "bold",
                }}
                onClick={() => {
                  console.log(kupon);
                }}
              >
                {kupon}
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Dialog>
  );
}
